import { useEffect, useState } from "react";
import api from "@/lib/api";
import { useSEO } from "@/lib/seo";
import LegalDocSections from "@/components/public/LegalDocSections";

export default function LegalPage({ page }) {
  const [doc, setDoc] = useState(null);
  const [pc, setPc] = useState(null);
  useEffect(() => {
    setPc(null);
    api.get("/website/sections/legal").then((r) => setDoc(r.data)).catch(() => setDoc({}));
    api.get("/public/page-content", { params: { path: `/${page}` } }).then((r) => setPc(r.data)).catch(() => setPc({}));
  }, [page]);

  const legacyTitle = doc?.[`${page}_title`] || "";
  const legacyBody = doc?.[`${page}_body`] || "";
  useSEO({ title: `${pc?.title || legacyTitle || "Legal"} — Training Basket`, description: (pc?.paragraphs?.[0] || legacyBody).replace(/<[^>]+>/g, "").slice(0, 150) });

  if (pc === null) return null;
  const hasPc = pc.title || (pc.paragraphs || []).length > 0;
  const data = hasPc
    ? pc
    : { title: legacyTitle, paragraphs: legacyBody.split("\n\n").filter(Boolean) };
  return <LegalDocSections data={data} pageKey={page} />;
}
